module.exports = __webpack_public_path__ + "static/media/Icon_Books_White.070aad70.png";